// import headerBg2 from "@/assets/images/active/sakura/info/header/bg.png";
// import officeBtn from "@/assets/images/active/sakura/info/header/website-btn.png";
// import loginBtn from "@/assets/images/active/sakura/info/header/login-btn.png";
// import accountBtn from "@/assets/images/active/sakura/info/header/change-btn.png";
// import logoutBtn from "@/assets/images/active/sakura/info/header/logout.png";

export const headerConfig = {
    not_logged_in: {
        background_image: 'https://download4.qcplay.com/h5-images/active/sakura/info/header/bg.png',
        style: "",
    },
    logged_in: {
        background_image: 'https://download4.qcplay.com/h5-images/active/sakura/info/header/bg.png',
        main_title_color: "#9F7558;font-size: 0.32rem;",
        sub_title_color: "#9F7558",
        tips_color: "#9F7558",
        game_name: "魔卡少女樱：回忆钥匙"
    },
    operation_btn: {
        login: {
            width: "",
            height: "",
            background_image: "",
            img: 'https://download4.qcplay.com/h5-images/active/sakura/info/header/login-btn.png',
            style: ""
        },
        office_website: {
            width: "",
            height: "",
            background_image: "",
            img: 'https://download4.qcplay.com/h5-images/active/sakura/info/header/website-btn.png',
            style: "",
            link: "https://sakura.qingcijoy.com/official/index.html"
        },
        change_account: {
            width: "",
            height: "",
            background_image: "",
            img: 'https://download4.qcplay.com/h5-images/active/sakura/info/header/change-btn.png',
            style: ""
        },
        join_active: {
            width: "",
            height: "",
            background_image: "",
            img: 'https://download4.qcplay.com/h5-images/active/sakura/info/header/website-btn.png',
            style: ""
        },
        logout: {
            width: "",
            height: "",
            img: 'https://download4.qcplay.com/h5-images/active/sakura/info/header/logout.png',
            style: ""
        }
    }
};



// WEBPACK FOOTER //
// ./src/pages/sakura/info/headerConfig.js